import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="min-h-[38dvh] grid place-items-center overflow-hidden">
      <div className="flex flex-col items-center">
        <h1 className="sm:text-base text-sm">Seems like you have wandered off, lets go back</h1>
        <Link to="/">
          <button className="w-20 bg-blue-400 text-white rounded-md p-2 mt-2 text-sm sm:text-base">
            Home
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Error;
